import React from 'react'
import PropTypes from 'prop-types'
import {
  Button, Icon, Collapse, Radio, Label,
} from 'shpmtcd'
import AddressInfo from '../containers/AddressInfo'

const { Panel } = Collapse

class AddressItem extends React.Component {
  render() {
    const {
      address,
      selectAddress,
      switchToEditMode,
      index,
      setSelectedAddressID,
      openDeleteModal,
      addressCount,
      fetchAllStates,
    } = this.props

    return (
      <Panel
        key={index}
        className={`address-info-panel ${address.default_contact && 'selected'}`}
        header={
          (
            <>
              <div
                className='address-item-container'
                onClick={(e) => {
                  e.stopPropagation()
                  selectAddress(address.id)
                }}
                onKeyPress={(e) => {
                  e.stopPropagation()
                  selectAddress(address.id)
                }}
              >
                <div className='address-wrapper'>
                  <div className={`default-address ${addressCount === 1 ? 'hide-default-address-margin' : ''}`}>
                    { address.default_contact && <Label type='Primary' className='font-w--bold'>DEFAULT</Label> }
                  </div>
                  <div className='radio-address-wrapper'>
                    <Radio defaultChecked={address.default_contact} value={address.id} className={`collapse-option__radio ${addressCount === 1 ? 'hide-radio' : ''}`} />
                    <div
                      className={`buyer-info-option ${address.default_contact ? 'selected' : ''}`}
                    >
                      <AddressInfo info={address} />
                    </div>
                  </div>
                </div>
                <div className='controls'>
                  <Button
                    type='Icon'
                    className='delete-button'
                    style={{ padding: '0' }}
                    onClick={(e) => {
                      e.stopPropagation()
                      openDeleteModal()
                      setSelectedAddressID(address.id)
                    }}
                  >
                    <Icon type='shpmtcdicon-trash' style={{ marginRight: '5px' }} />
                    <p>Delete</p>
                  </Button>
                  <Button
                    type='Default'
                    className='edit-button'
                    onClick={(e) => {
                      e.stopPropagation()
                      switchToEditMode()
                      setSelectedAddressID(address.id)
                      fetchAllStates(address.address_hash.country)
                    }}
                  >
                    Edit
                  </Button>
                </div>
              </div>
            </>
          )
        }
      />
    )
  }
}

AddressItem.propTypes = {
  selectAddress: PropTypes.func.isRequired,
  switchToEditMode: PropTypes.func.isRequired,
  fetchAllStates: PropTypes.func.isRequired,
  setSelectedAddressID: PropTypes.func.isRequired,
  openDeleteModal: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  addressCount: PropTypes.number.isRequired,
  address: PropTypes.shape({
    address_hash: PropTypes.shape({
      city: PropTypes.string,
      country: PropTypes.string,
      postcode: PropTypes.string,
      poboxnumber: PropTypes.string,
      street_address: PropTypes.string,
    }),
    default_contact: PropTypes.bool,
    selected: PropTypes.bool,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
}

export default AddressItem
